import {
    UPDATE_PROGRESS_STEP,
    UPDATE_INBOUND_SELECTION,
    UPDATE_OUTBOUND_SELECTION,
    UPDATE_TRANSACTIONAL_SELECTION,
    UPDATE_CART_START,
    UPDATE_CART_SUCCESS,
    UPDATE_CART_ERROR,
    FETCH_CART_START,
    FETCH_CART_SUCCESS,
    FETCH_CART_ERROR,
    APPLY_COUPON_START,
    APPLY_COUPON_SUCCESS,
    APPLY_COUPON_ERROR,
} from "../reducers/appContextReducer";

const updateProgressStep = stepIndex => ({
    type: UPDATE_PROGRESS_STEP,
    payload: stepIndex,
});

const updateInbound = ({ planHandle, allocation, coupons }) => ({
    type: UPDATE_INBOUND_SELECTION,
    payload: {
        planHandle,
        allocation,
        coupons,
    },
});

const updateOutbound = ({ planHandle, allocation, coupons }) => ({
    type: UPDATE_OUTBOUND_SELECTION,
    payload: {
        planHandle,
        allocation,
        coupons,
    },
});

const updateTransactional = ({ planHandle, coupons }) => ({
    type: UPDATE_TRANSACTIONAL_SELECTION,
    payload: {
        planHandle,
        coupons,
    },
});

const updateCartStart = () => ({
    type: UPDATE_CART_START,
});

const updateCartSuccess = cart => ({
    type: UPDATE_CART_SUCCESS,
    payload: cart,
});

const updateCartError = error => ({
    type: UPDATE_CART_ERROR,
    payload: error,
});

const fetchCartStart = () => ({
    type: FETCH_CART_START,
});

const fetchCartSuccess = cart => ({
    type: FETCH_CART_SUCCESS,
    payload: cart,
});

const fetchCartError = error => ({
    type: FETCH_CART_ERROR,
    payload: error,
});

const applyCouponStart = () => ({
    type: APPLY_COUPON_START,
});

const applyCouponSuccess = cart => ({
    type: APPLY_COUPON_SUCCESS,
    payload: cart,
});

const applyCouponError = error => ({
    type: APPLY_COUPON_ERROR,
    payload: error,
});

export {
    updateProgressStep,
    updateInbound,
    updateOutbound,
    updateTransactional,
    updateCartStart,
    updateCartSuccess,
    updateCartError,
    fetchCartStart,
    fetchCartSuccess,
    fetchCartError,
    applyCouponStart,
    applyCouponSuccess,
    applyCouponError,
};
